/** @jsxImportSource @emotion/react */
import { Button, Input, Select } from '@quickbit/qb-design-system';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { COUNTRY_OPTIONS } from '../../../utils';
import { Section } from '../components';
import { MerchantContext } from '../SignUp';
import { isValidEmail } from '../utils';

export const GeneralInformation = () => {
  const navigate = useNavigate();
  const { merchantUseForm, kybUseForm, email, setEmail, onUpdateQueryParam } =
    useOutletContext<MerchantContext>();

  const invalidEmail = !isValidEmail(email);

  const {
    fields: merchantForm,
    setters: merchantFormSetters,
    errors: merchantFormErrors,
    hasErrors: merchantFormHasErrors,
  } = merchantUseForm;

  const {
    fields: kybForm,
    setters: kybFormSetters,
    errors: kybFormErrors,
  } = kybUseForm;

  const autofill = () => {
    kybFormSetters.fullCompanyName.set('Quickbit Eu AB (publ)');
    kybFormSetters.registrationNumber.set('559265-3793');
    kybFormSetters.incorporationCountry.set('SE');
    merchantFormSetters.countryCode.set('SE');
    merchantFormSetters.name.set('Quickbit Eu AB (publ)');
    const randomPart = Math.random().toString(36).substring(2, 8); // e.g. "k9z4xq"
    setEmail(`test+${randomPart}@quickbit.com`);
  };

  return (
    <>
      <Section>
        <Input
          label="Email address"
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          value={email ?? ''}
          onChange={(e) => setEmail(e.target.value)}
          helperText={invalidEmail ? 'Please enter a valid email' : undefined}
          error={invalidEmail}
          onBlur={(e) => onUpdateQueryParam('email', e.target.value)}
        />
        <Input
          label="Company name"
          value={kybForm.fullCompanyName}
          onChange={(e) => {
            kybFormSetters.fullCompanyName.set(e.target.value);
            merchantFormSetters.name.set(e.target.value);
          }}
          onBlur={(e) => onUpdateQueryParam('fullCompanyName', e.target.value)}
          helperText={
            kybFormErrors.fullCompanyName ??
            'This is the legal name. E.g. Valuno Group AB'
          }
          error={!!kybFormErrors.fullCompanyName}
        />
        <Select
          label="Country of incorporation"
          options={COUNTRY_OPTIONS}
          values={
            merchantForm.countryCode ? [merchantForm.countryCode] : undefined
          }
          onSelect={([selected]) => {
            merchantFormSetters.countryCode.set(selected || '');
            kybFormSetters.incorporationCountry.set(selected || '');
            onUpdateQueryParam('countryCode', selected || '');
            onUpdateQueryParam('incorporationCountry', selected || '');
          }}
          helperText={
            merchantFormErrors.countryCode ??
            kybFormErrors.incorporationCountry ??
            undefined
          }
          error={
            !!merchantFormErrors.countryCode ||
            !!kybFormErrors.incorporationCountry
          }
        />
        <Input
          label="Registration number"
          value={kybForm.registrationNumber}
          onChange={(e) =>
            kybFormSetters.registrationNumber.set(e.target.value)
          }
          onBlur={(e) => {
            onUpdateQueryParam('registrationNumber', e.target.value);
          }}
          error={!!kybFormErrors.registrationNumber}
          helperText={kybFormErrors.registrationNumber}
        />
      </Section>
      <Section>
        <div css={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div
            css={{
              display: 'inline-flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              text="Next"
              variant="primary"
              style={{ width: 'auto', display: 'inline-block' }}
              onClick={() => {
                kybFormSetters.registrationNumber.set(
                  kybForm.registrationNumber
                );
                if (kybForm.registrationNumber) {
                  navigate(
                    `/sign-up/business-information${window.location.search}`
                  );
                }
              }}
              disabled={
                !!kybFormErrors.registrationNumber ||
                merchantFormHasErrors ||
                invalidEmail
              }
            />
            {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
              <Button
                style={{ marginLeft: '8px' }}
                text="autofill"
                variant="primary"
                onClick={autofill}
              />
            )}
          </div>
        </div>
      </Section>
    </>
  );
};
